import { render } from "./EndpointSelect.vue?vue&type=template&id=05cfbc63&scoped=true&ts=true"
import script from "./EndpointSelect.vue?vue&type=script&lang=ts"
export * from "./EndpointSelect.vue?vue&type=script&lang=ts"

import "./EndpointSelect.vue?vue&type=style&index=0&id=05cfbc63&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cfbc63"]])

export default __exports__